import React, { useRef, useState } from "react"
import { Form, Button, Card, Alert } from "react-bootstrap"
import { useAuth } from "../../contexts/AuthContext"
import { Link } from "react-router-dom"
import CenteredContainer from '../centeredcontainer/CenteredContainer'
import Header from '../header/Header'
import Footer from '../footer/Footer'

export default function ForgotPassword() {
  const emailRef = useRef()
  const { resetPassword } = useAuth()
  const [error, setError] = useState("")
  const [message, setMessage] = useState("")
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()

    try {
      setMessage("")
      setError("")
      setLoading(true)
      await resetPassword(emailRef.current.value)
      setMessage("Check your inbox for further instructions")
    } catch {
      setError("Failed to reset password")
    }

    setLoading(false)
  }

  return (
    <div>
      <Header />
      <CenteredContainer>
        <Card>
          <Card.Body>
            <h2 className="text-center mb-1">استعادة كلمة المرور</h2>
            {error && <Alert variant="danger">{error}</Alert>}
            {message && <Alert variant="success">{message}</Alert>}
            <Form onSubmit={handleSubmit}>
              <Form.Group id="email">
                <Form.Label>البريد الإلكتروني</Form.Label>
                <Form.Control type="email" ref={emailRef} required />
              </Form.Group>
              <Button disabled={loading} className="w-100 mt-2" type="submit">
                استعادة كلمة المرور
              </Button>
            </Form>
            <div className="w-100 text-center mt-3">
              <Link to="/signin">تسجيل الدخول</Link>
            </div>
          </Card.Body>
        </Card>
        <div className="w-100 text-center mt-2">
          تسجيل مستخدم جديد <Link to="/signup">التسجيل</Link>
        </div>
      </CenteredContainer>
      <Footer />
    </div>
  )
}
